<!--社区艺术培训机构&专业资源单位-->
<template>
    <div class="sec content mt20" id="shequInstitu">
        <div class="tab-head myflex-v">
            <div class="tab-item tabTitle myflex-v">
                <i class="el-icon-pie-chart title-icon myhide"></i><img src="@/assets/img/icon5.png" class="title-icon-img" /><span>美育地图：艺术教育资源共享</span>
            </div>
            <div class="sec-right-up myflex-v marginauto-l">
                <el-input placeholder="请输入要查询的教师姓名" v-model="searchval" class="mr15 width200 myhide" size="small">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="startSearch"></i>
                </el-input>
                <div class="look-more" @click="toList">查看更多<i class="el-icon-arrow-right"></i></div>
            </div>
        </div>
        <div class="pad15 myflex mainBox">
            <div class="map mr20">
                <div class="my-map" id="my-map"></div>
            </div>
            <div class="flex1 mapRightBox">
                <el-tabs v-model="activeName" @tab-click="search">
                    <el-tab-pane name="first">
                        <template v-slot:label>
                            <b class="tabTitle">艺术专业单位</b>
                        </template>
                        <template>
                            <div class="list-box list-box1" ref="listBox1" v-loading="loading1">
                                <template v-if="studioList.length">
                                    <div class="list-item" v-for="(cItem1,cIndex1) in studioList" :key="cIndex1" @click="toStudioDetail(cItem1.id)">
                                        <el-image :src="art.addOssResize(cItem1.studioPhoto,100)" lazy class="list-cover mr15"
                                            @click="art.delayRollAuto()"></el-image>
                                        <div class="flex1 list-fontBox">
                                            <div class="fon14 ellipsis1 mb5">
                                                <span class="fweight">{{cItem1.studioName}}</span>
                                            </div>
                                            <div class="ellipsis1 mb5">专业：{{cItem1.majorNames ? cItem1.majorNames : '暂无~'}}</div>
                                            <div class="myflex-v">
                                                <div class="list-label mr10">{{studioLevels[cItem1.studioLevel-1].label}}</div>
                                            </div>
                                            <div v-if="cItem1.studioLevel==3 && cItem1.labelNames" class="myflex-v flexWrap mt5">
                                                <span v-for="(li,liIndex) in cItem1.labelNames.split(',')" :key="liIndex" class="labelIconItem myflex-v">
                                                    <img src="@/assets/img/labelcon.png" lazy class="labelcon"/>
                                                    <span>{{li}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </template>   
                                <div v-else class="nodata pad15">暂无数据~</div>
                            </div>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                        <template v-slot:label>
                            <b class="tabTitle">共享行动单位</b>
                        </template>
                        <template>
                            <div class="list-box list-box2" ref="listBox2" id="listBox2" v-loading="loading2">
                                <template v-if="instList.length">
                                    <div class="list-item" v-for="(cItem2,cIndex2) in instList" :key="cIndex2" @click="toStudioDetail(cItem2.id)">
                                        <el-image :src="art.addOssResize(cItem2.studioPhoto,100)" lazy class="list-cover mr15"
                                            @click="art.delayRollAuto()"></el-image>
                                        <div class="flex1 list-fontBox">
                                            <div class="fon14 ellipsis1 mb5">
                                                <span class="fweight">{{cItem2.studioName}}</span>
                                            </div>
                                            <div class="ellipsis1 mb5">专业：{{cItem2.majorNames ? cItem2.majorNames : '暂无~'}}</div>
                                            <div class="myflex-v">
                                                <div class="list-label mr10">{{studioLevels[cItem2.studioLevel-1].label}}</div>
                                            </div>
                                            <div v-if="cItem2.studioLevel==3 && cItem2.labelNames" class="myflex-v flexWrap mt5">
                                                <span v-for="(li,liIndex) in cItem2.labelNames.split(',')" :key="liIndex" class="labelIconItem myflex-v">
                                                    <img src="@/assets/img/labelcon.png" lazy class="labelcon"/>
                                                    <span>{{li}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div v-else class="nodata pad15">暂无数据~</div>
                            </div>
                        </template>
                    </el-tab-pane>
                </el-tabs>

            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .map{width:680px;height:382px;border:1px solid #ddd;background:#ebebeb;}
    .searchHead{border-bottom:1px solid #aaa;}
    .searchItem{padding-bottom:10px;cursor:pointer;font-weight:600;font-size:16px;margin-right:30px;}
    .searchItem.active{color:$theme-color;}
    .list-item{border-bottom:1px dotted #ddd;padding:10px 10px 10px 0;overflow:hidden;cursor:default;padding-left:85px;position: relative;}
    .list-item:last-child{border-bottom:none;}
    .list-cover{width:70px;height:70px;min-width:70px;border:1px solid #ddd;position:absolute;left:0;top:10px;}
    .list-fontBox{color:#333;font-size:14px;}
    .list-label{border-radius:1px;background:#ddd;color:#333;font-size:12px;padding:1px 4px;display:inline-block;}
    .my-map{width:100%;height:100%;min-width:300px;}
    .list-box{height:320px;overflow:auto;width:500px;}
    .labelIconItem{color:rgba(243,120,59,1);background:#fef1eb;font-size:12px;padding:0px 4px 0 0px;line-height:1;margin:2px 6px 2px 6px;border-radius:2px;}
    .labelcon{height:17px;position:relative;left:-5px;}
    @media screen and(max-width:1200px){
        .mainBox{flex-wrap:wrap;}
        .map{margin:0 0 10px 0 !important;width:100%;}
        .mapRightBox{width:100%;}
        .list-box{width:100%;}
    }
</style>

<script>
import { mapState } from 'vuex';
import CourseListItem from '@/components/CourseListItem.vue';
import axios from '@/axios'; // 导入axios实例
import QRCode from 'qrcode'; 
import qs from 'qs'; // 根据需求是否导入qs模块

export default {
    name: "shequInstitu",
    components: {
        CourseListItem,
    },
    data(){
        return {
            art: art,
            searchval: '',
            studioList: [],
            instList: [],
            instListForMap: [],
            map: null,
            activeName: 'first',
            hasClickSecond: false, //记录是否第一次点击机构列表（为解决机构列表懒加载图片不加载的问题）
            studioLevels:[],
            loading1: true,
            loading2: true,
        }
    },
    computed:{
        cityName:{
            get(){
                return this.$store.state.cityInfo.cityName;
            },
            set(){

            },
        }
    },
    methods: {
        search: function(obj){;
            if( obj.paneName=='second' ){
                if( !this.hasClickSecond ){
                    console.log('second');
                    setTimeout(()=>{
                        this.$refs.listBox2.scrollTop=1;
                        console.log('解决el-image不加载图片的问题');
                    },1)
                    this.hasClickSecond = true;
                }
            }
        },

        startSearch: function(){
            console.log('search');
        },

        //获取美育地图上的机构列表
        getInstListForMap(){
            var data = {
                city: this.cityName,
            }
            this.$api.inst.selectStudioListForMap(data).then(res=>{
                this.instListForMap = res.body.studioList;
                this.clearMap();
                this.addPoint();
            }).catch(res=>{
            })
        },

        //获取共享行动单位列表
        getInstList(){
            var data = {
                city: this.cityName,
                pageNum: 1,
                pageSize:10,
            }
            this.$api.web.artmapOfStudioEvaluationSelectStudioAllianceList(data).then(res=>{
                this.instList = res.body.studioList;
                //this.addPoint();
                this.loading2 = false;
            }).catch(res=>{
                this.loading2 = false;
            })
        },

        //获取工作室列表
        getStudioList(){
            var data = {
                pageNum: 1,
                pageSize:10,
            }
            this.$api.inst.artmapOfStudioEvaluationSelectStudioList(data).then(res=>{
                this.studioList = res.body.studioList;
                this.loading1 = false;
            }).catch(res=>{
                this.loading1 = false;
            })
        },

        //跳转到机构详情
        toInstDetail(id,userId){
            const newurl = this.$router.resolve({name: 'instDetail', query: {id:id, userId: userId}})
            window.open(newurl.href,'_blank');
        },

        //跳转到工作室详情
        toStudioDetail(id,userId){
            const newurl = this.$router.resolve({name: 'studioDetail', query: {id: id}})
            window.open(newurl.href,'_blank');
        },

        //跳到单位列表页面
        toList(){
            const newurl = this.$router.resolve({name: 'instStudioList', query: {}})
            window.open(newurl.href,'_blank');
        },

        //初始化地图
        initMap(){
            //百度地图
            this.map = new BMap.Map("my-map");
            var map = this.map;
            map.centerAndZoom('武汉', 5);
            //map.enableScrollWheelZoom();
            map.enableContinuousZoom();
            // 添加带有定位的导航控件
            var navigationControl = new BMap.NavigationControl({
                // 靠左上角位置
                anchor: BMAP_ANCHOR_TOP_LEFT,
                // LARGE类型
                type: BMAP_NAVIGATION_CONTROL_LARGE,
                // 启用显示定位
                enableGeolocation: true
            });
            map.addControl(navigationControl);
            // 添加定位控件
            var geolocationControl = new BMap.GeolocationControl();
            geolocationControl.addEventListener("locationSuccess", function(e){
                // 定位成功事件
                var address = '';
                address += e.addressComponent.province;
                address += e.addressComponent.city;
                address += e.addressComponent.district;
                address += e.addressComponent.street;
                address += e.addressComponent.streetNumber;
            });
            geolocationControl.addEventListener("locationError",function(e){
                // 定位失败事件
                this.$message(e.message);
            });
            map.addControl(geolocationControl);
        },

        
        //清空地图上的标记
        clearMap: function () {
            if(this.map){
                this.map.clearOverlays();
                //this.map.clearLabels();
            }
        },

        //地图上加点
        addPoint(){
            var vm = this;
            // 百度地图API功能	
            var map = this.map;
            //map.centerAndZoom(new BMap.Point(116.417854,39.921988), 15);
            var data_info = this.instListForMap;
            var add,province,city,area,studioAddressDetail,address;
            for(var i=0;i<data_info.length;i++){
                add = data_info[i];
                console.log(add.studioLevel,'studioLevel')
                var marker = new BMap.Marker(new BMap.Point(add.lng,add.lat), {
                    icon: new BMap.Icon(require('@/assets/img/map/marker'+add.studioLevel+'.png'), new BMap.Size(27,60)),
                });
                //var marker1 = new BMap.Marker(new BMap.Point(data_info[i].lng,data_info[i].lat));  // 创建标注
                province = add.province ? add.province : '';
                city = add.city ? add.city : '';
                area = add.area ? add.area : '';
                studioAddressDetail = add.studioAddressDetail ? add.studioAddressDetail : '';
                address = province+city+area+studioAddressDetail;
                var content =
                    '<div onclick="toInstDetail('+data_info[i].id+','+data_info[i].userId+')" class="mr10">\
                        <h4 class="fon16 fweight mb5 ellipsis1">'+data_info[i].studioName+'</h4>\
                        <div class="fon14 cor999 mb10">'+(data_info[i].majorNames ? data_info[i].majorNames : '暂无专业信息')+'<br/> <span>'+address+'</span></div>\
                    </div>';
                map.addOverlay(marker);// 将标注添加到地图中
                //map.addOverlay(marker1)
                addClickHandler(content,marker,data_info[i].id);
            }
            //添加事件
            function addClickHandler(content,marker,id){
                marker.addEventListener("click",function(e){
                    //制作二维码
                    vm.makeCode(id,function(codeUrl){
                        var codeHtml = 
                        '<div class="codeOutBox myflex-v">\
                            <img class="codeImg mr10" style="width:80px;" src="'+codeUrl+'" alt="二维码"/>\
                            <div class="cor666">微信扫描二维码进入机构小程序</div>\
                        </div>';
                        content = content.split('<div class="codeOutBox myflex-v">')[0];
                        content = content+codeHtml;
                        openInfo(content,e);
                    })
                });
            }
            //打开信息框
            function openInfo(content,e){
                var p = e.target;
                var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
                var infoWindow = new BMap.InfoWindow(content);  // 创建信息窗口对象 
                map.openInfoWindow(infoWindow,point);
            }
        },
        
        //绘制小程序二维码
        makeCode: function(id,callback){
            var url = 'https://www.artapp.cn/miniProgram?recoWXStudioId='+id;
            var opts = {
                errorCorrectionLevel: 'H',
                type: 'image/jpeg',
                quality: 0.3,
                margin: 1,
                color: {
                    dark:"#000000",
                    light:"#ffffff"
                }
            }
            QRCode.toDataURL(url, opts, function (err, baseUrl) {
                if (err){
                }else{
                    callback(baseUrl);
                }  
            })
        },
    },

    created: function(){
        window.toInstDetail = this.toInstDetail;
        //工作室等级
        art.getStudioLevels(res=>{
            this.studioLevels = res;
        })
        setTimeout(()=>{
            this.getStudioList();
        },2500)
        
    },
    mounted: function(){
        var vm = this;
        this.initMap();
        setTimeout(()=>{
            if( !this.cityName ){
                vm.$store.getters['cityInfo/baiduLocation']((res)=>{
                    vm.cityName = res;
                    vm.getInstList();
                    vm.getInstListForMap();
                })
            }else{
                vm.getInstList();
                vm.getInstListForMap();
            }
        },3000)
    }
}
</script>